import React from 'react';

import type { Apollo } from 'src/gql/generated';
import type { WorkflowRecipientAction, WorkflowStep } from 'src/workflow';
import { RecipientActionRow, useDragAction } from 'src/workflow';

export type ActionWithStep = WorkflowRecipientAction & { step: WorkflowStep };

interface ActionRowProps {
  action: ActionWithStep;
  workflowId: UUID;
  workflowState: Apollo.WorkflowState;
}

export function ActionRow({
  action,
  workflowId,
  workflowState,
}: ActionRowProps): JSX.Element | null {
  const {
    drag: [, dragRef],
    dragClasses,
  } = useDragAction(workflowId, action);

  return (
    <RecipientActionRow
      ref={dragRef}
      className={dragClasses.dragStyles}
      recipientAction={action}
      workflowId={workflowId}
      workflowState={workflowState}
    />
  );
}
